module.exports = __webpack_public_path__ + "img/2.3a8d6f9c.png";